import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <rect width={512} height={512} rx={82} fill="#7f00ff" />
    <g fill="#fff">
      <path d="M255 96c11-1 20 5 25 16l61 125c7 15 1 25-11 27-9 2-16-1-23-8l-96-79c-8-7-10-15-5-25l27-47c5-7 12-9 22-9Z" />
      <path d="M198 195c7-3 14-1 21 5l44 38c7 7 9 14 5 23l-58 128c-4 8-10 12-20 12h-65c-12 0-20-5-24-14-3-7-2-15 2-24l78-158c4-6 10-9 17-10Z" />
      <path d="M276 291h73c10 0 17 5 22 15l35 77c5 11 2 18-7 18h-73c-11 0-19-5-24-16l-36-77c-5-11-2-17 10-17Z" />
      <circle cx={428} cy={442} r={21} />
    </g>
  </svg>
);
